///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    $(document).on("input", ".clearable", function() {
        $(this).toggleClass('x', this.value != '');
    }).on("mousemove", ".x", function(e) {
        $(this).toggleClass('onX', this.offsetWidth - 25 < e.clientX-this.getBoundingClientRect().left);
    }).on("touchstart click", ".onX", function(ev) {
        ev.preventDefault();
        $(this).removeClass('x onX').val('').trigger('keyup').trigger('change').trigger('xOff');
    });
});
